export const DEFAULT_IMAGE_MAP_WEBP = '/static/images/map/defaultmap.webp';
export const DEFAULT_IMAGE_MAP_JPG = '/static/images/map/defaultmap.jpg';
